import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-watch-video',
  templateUrl: './watch-video.component.html',
  styles: [
  ]
})
export class WatchVideoComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<WatchVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {src: string, poster: string, caption?:string} = {
      src: '', poster: ''
    }
  ) { }

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close()
  }

}
